export var isErrorResponse = function isErrorResponse(response) {
  return typeof response === 'object' && response.isSuccess === false;
};